// Web notifications + tiny helpers.

export function notificationsSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function notificationPermission(): NotificationPermission | 'unsupported' {
  if (!notificationsSupported()) return 'unsupported';
  return Notification.permission;
}

export async function requestNotifications(): Promise<NotificationPermission | 'unsupported'> {
  if (!notificationsSupported()) return 'unsupported';
  try { return await Notification.requestPermission(); } catch { return Notification.permission; }
}

export function notify(title: string, body: string) {
  if (!notificationsSupported() || Notification.permission !== 'granted') return;
  const opts = { body, icon: '/icons/icon192.png', badge: '/icons/icon192.png' };
  // On iPhone (installed PWA) and Android the Notification constructor doesn't show anything:
  // notifications have to go through the service worker. Desktop falls back to the constructor.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration()
      .then((reg) => (reg ? reg.showNotification(title, opts) : Promise.reject()))
      .catch(() => { try { new Notification(title, opts); } catch { /* ignore */ } });
    return;
  }
  try { new Notification(title, opts); } catch { /* ignore */ }
}
